import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import './ReviewsBadge.sass';

import StarRating from './stars/StarRating';
import { fetchReviewsTotal, REVIEWS_AVERAGE_RATING } from '../../ducks/reviews';

const TRUSTPILOT_URL = 'https://www.trustpilot.com/review/boosthive.net';
const TRUSTPILOT_RATING = '4.2';
const GOOGLE_URL = 'https://www.google.com/storepages?q=boosthive.eu&c=US&v=19&so=MOST_HELPFUL#reviews';
const GOOGLE_RATING = '4.9';

const StarIcon = ({ size = 16, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 14 14" fill="none">
    <path
      d="M6.71468 0.878114C6.80449 0.601721 7.19551 0.601722 7.28532 0.878115L8.72876 5.32057C8.76892 5.44418 8.88411 5.52786 9.01408 5.52786H13.6851C13.9758 5.52786 14.0966 5.89975 13.8615 6.07057L10.0825 8.81616C9.97736 8.89255 9.93336 9.02796 9.97352 9.15157L11.417 13.594C11.5068 13.8704 11.1904 14.1003 10.9553 13.9294L7.17634 11.1838C7.07119 11.1074 6.92881 11.1075 6.82366 11.1838L3.04469 13.9294C2.80957 14.1003 2.49323 13.8704 2.58303 13.594L4.02648 9.15157C4.06664 9.02796 4.02264 8.89255 3.91749 8.81616L0.138516 6.07057C-0.0965979 5.89975 0.0242358 5.52786 0.314853 5.52786H4.98593C5.11589 5.52786 5.23108 5.44418 5.27124 5.32057L6.71468 0.878114Z"
      fill={color}
    />
  </svg>
);

const ReviewsBadge = ({
  averageRating = REVIEWS_AVERAGE_RATING,
  reviewsCount,
  dispatch,
  storeTotal,
  withExternalLinks = false,
}) => {
  // Prefer a count supplied by the parent (e.g. the page it is embedded in);
  // otherwise fall back to the site-wide total from the reviews duck.
  const count = reviewsCount != null ? reviewsCount : storeTotal;

  useEffect(() => {
    if (reviewsCount == null && storeTotal === undefined) {
      dispatch(fetchReviewsTotal());
    }
  }, []);

  if (count == null) {
    return null;
  }

  const badge = (
    <div className="reviews-badge">
      <div className="reviews-badge__left">
        <span className="reviews-badge__title">Excellent</span>

        <div className="reviews-badge__rating">
          <StarRating value={Math.ceil(Number(averageRating))} size={18} />
        </div>
      </div>

      <div className="reviews-badge__count">
        <span>
          <span className="reviews-badge__count-number  reviews-badge__count-number--rating">{averageRating}</span>
          &nbsp;
          <FormattedMessage id="section.reviews.slider.average" />
        </span>

        <span>
          <span className="reviews-badge__count-number">{count}</span>
          &nbsp;
          <FormattedMessage id="section.reviews.slider.reviews" />
        </span>
      </div>
    </div>
  );

  if (!withExternalLinks) {
    return badge;
  }

  return (
    <div className="reviews-badge-row">
      {badge}

      <a
        className="reviews-badge-link"
        href={TRUSTPILOT_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="reviews-badge-link__star">
          <StarIcon size={16} color="#00b67a" />
        </span>
        <span className="reviews-badge-link__rating">{TRUSTPILOT_RATING}</span>
        <span className="reviews-badge-link__name">Trustpilot</span>
      </a>

      <a
        className="reviews-badge-link"
        href={GOOGLE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="reviews-badge-link__star">
          <StarIcon size={16} color="#f1be44" />
        </span>
        <span className="reviews-badge-link__rating">{GOOGLE_RATING}</span>
        <span className="reviews-badge-link__name">Google</span>
      </a>
    </div>
  );
};

export default connect(({ reviews }) => ({ storeTotal: reviews.total }))(ReviewsBadge);



// WEBPACK FOOTER //
// ./components/reviews/ReviewsBadge.js